"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputJumpExtensionDefinition = void 0;
const WidgetExtensionPlugin_1 = require("auto-widget-framework/src/Plugin/WidgetExtension/WidgetExtensionPlugin");
const WidgetExtensionPluginDefinition_1 = require("auto-widget-framework/src/Plugin/WidgetExtension/WidgetExtensionPluginDefinition");
const IContainerInjection_1 = require("auto-widget-framework/src/Container/IContainerInjection");
const Mixin_1 = require("auto-widget-framework/src/Util/Mixin");
const WidgetEvents_1 = require("auto-widget-framework/src/Widget/EventDefinition/WidgetEvents");
class InputJumpExtension extends WidgetExtensionPlugin_1.default {
    constructor(definition) {
        super(definition);
    }
    static create(definition) {
        return new this(definition);
    }
    /**
     * @inheritDoc
     */
    initialize(widget) {
        this.widget = widget;
        this.widget.getEventContainer().on(WidgetEvents_1.WidgetEvents.STEP_READY, this.registerInputJumpEvents.bind(this));
        return Promise.resolve();
    }
    /*
     * Register events for all the matched criteria found on the step
     */
    registerInputJumpEvents() {
        const inputs = this.widget.getContainer().querySelectorAll(`input[maxlength]`);
        for (let i = 0, input; input = inputs[i]; ++i) {
            input.addEventListener("input", this.jumpFocus.bind(this));
        }
    }
    /*
     * Jump focus for date inputs
     */
    jumpFocus(event) {
        const selectedInput = event.target;
        if (selectedInput.hasAttribute("maxlength") &&
            selectedInput.getAttribute("maxlength") <= selectedInput.value.length &&
            selectedInput.nextElementSibling !== null) {
            selectedInput.nextElementSibling.focus();
        }
    }
}
exports.default = InputJumpExtension;
Mixin_1.default(InputJumpExtension, IContainerInjection_1.default);
exports.InputJumpExtensionDefinition = new WidgetExtensionPluginDefinition_1.default({
    id: "input_jump",
    class: InputJumpExtension
});
